import Policies from './Policies';
import Sectors from "./Sectors";
import Metrics from "./Metrics";
import City from "./City";

export default class Store {

    constructor(state = {}, cityId) {
        this.policies = new Policies(state, cityId);
        this.sectors = new Sectors(state, cityId);
        this.metrics = new Metrics(state);
        this.city = new City(state, cityId);
    }
}
